<p-tieredMenu [model]="menuItems" (mouseleave)="onMouseLeave($event)"></p-tieredMenu>